import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'pages.myAccount.appointment.title',
    description: 'Title for the appointment section',
    defaultMessage: 'Reschedule an Appointment',
  },
});
